import script from "./PostToSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PostToSearch.vue?vue&type=script&setup=true&lang=js"

import "./PostToSearch.vue?vue&type=style&index=0&id=2f0b23c5&lang=scss"

const __exports__ = script;

export default __exports__